export default "__VITE_ASSET__39635fbc__"